import type { GetProjectCatalogQuery } from '@/graphql/types';

export type ProjectSummary = NonNullable<
    NonNullable<GetProjectCatalogQuery['projectCatalog']>['summaries']
>[number];
export type ProjectRowSummary = Pick<
    ProjectSummary,
    'online' | 'offline' | 'inactive' | 'dataWarnings' | 'recentExceedances'
>;

const EMPTY_DATA_WARNINGS: ProjectSummary['dataWarnings'] = {
    count: 0,
    devices: [],
};
const EMPTY_RECENT_EXCEEDANCES: ProjectSummary['recentExceedances'] = {
    count: 0,
    events: [],
};

export function buildEmptyProjectSummary(): ProjectRowSummary {
    return {
        online: 0,
        offline: 0,
        inactive: 0,
        dataWarnings: EMPTY_DATA_WARNINGS,
        recentExceedances: EMPTY_RECENT_EXCEEDANCES,
    };
}
